import { render, staticRenderFns } from "./changepost.vue?vue&type=template&id=1237f702&"
import script from "./changepost.vue?vue&type=script&lang=js&"
export * from "./changepost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports